import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LanguageModule } from '@language';
import { BaseContainer, ShNotificationComponent } from '@stylehaven/components';
import { ErrorPageTemplate } from './error-page.template';

@Component({
    standalone: true,
    imports: [ShNotificationComponent, LanguageModule],
    selector: 'med-page-not-found-container',
    template: ErrorPageTemplate,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class ErrorPageContainerComponent extends BaseContainer {
    protected abstract title: string;
    protected abstract message: string;

    @Input() noMargin: boolean = false;
    public constructor() {
        super();
    }
}
